"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAvailability = void 0;
exports.findStartedLessons = findStartedLessons;
exports.findOpenLessons = findOpenLessons;
exports.findDefaultableSlots = findDefaultableSlots;
exports.findSlotAvailabilityIssue = findSlotAvailabilityIssue;
exports.isSlotBlocked = isSlotBlocked;
exports.findRoomAvailabilityConflict = findRoomAvailabilityConflict;
exports.isLocationRoomAvailable = isLocationRoomAvailable;
exports.findTeacherAvailabilityConflict = findTeacherAvailabilityConflict;
exports.isTeacherAvailable = isTeacherAvailable;
const _ = __importStar(require("lodash"));
const dayjs_1 = __importDefault(require("dayjs"));
const isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
const utils_1 = require("../utils");
dayjs_1.default.extend(isBetween_1.default);
const calculateAvailability = (data, params) => {
    const slotsData = (0, utils_1.addRangeToPeriods)(_.map(data.slots, (slot) => (Object.assign({ defaultTeacherData: data.teachers[slot.defaultTeacher], offerItemData: data.offer[slot.code] }, slot))));
    const currentLessons = _.reduce(_.values(data.registrations), (acc, registration) => {
        for (const registrationLesson of registration.lessons) {
            const lessonMatch = _.find(acc, {
                slot: registrationLesson.slot,
                teacher: registrationLesson.teacher,
            });
            if (lessonMatch) {
                lessonMatch.participants.push(registration.client);
            }
            else {
                if (!data.slots[registrationLesson.slot]) {
                    console.log('NO SLOT FOR:', registrationLesson.slot);
                }
                acc.push({
                    slot: registrationLesson.slot,
                    teacher: registrationLesson.teacher,
                    participants: [registration.client],
                    teacherData: data.teachers[registrationLesson.teacher],
                    slotData: (0, utils_1.addRangeToPeriod)(data.slots[registrationLesson.slot]),
                    offerItemData: data.offer[data.slots[registrationLesson.slot].code],
                });
            }
        }
        return acc;
    }, []);
    return _.reject([
        ..._.map(findOpenLessons(params, currentLessons), (lesson) => {
            var _a;
            const slot = lesson.slotData;
            const lessonsStudentsCount = slot.lessons ? ((_a = _.maxBy(slot.lessons, (lesson) => lesson.students.length)) === null || _a === void 0 ? void 0 : _a.students.length) || 0 : 0;
            return {
                slot: lesson.slotData,
                teachers: [lesson.teacher],
                capacity: {
                    current: lesson.participants.length + lessonsStudentsCount,
                    limit: lesson.offerItemData.capacity,
                },
            };
        }),
        ..._.map(findStartedLessons(params, slotsData), (slot) => {
            var _a, _b;
            const lessonsStudentsCount = slot.lessons ? ((_a = _.maxBy(slot.lessons, (lesson) => lesson.students.length)) === null || _a === void 0 ? void 0 : _a.students.length) || 0 : 0;
            return {
                slot: data.slots[slot.id],
                teachers: [slot.defaultTeacher],
                capacity: {
                    current: lessonsStudentsCount + (((_b = slot === null || slot === void 0 ? void 0 : slot.reservations) === null || _b === void 0 ? void 0 : _b.length) || 0),
                    limit: slot.offerItemData.capacity,
                },
            };
        }),
        ..._.map(findDefaultableSlots(params, slotsData, currentLessons), (slot) => ({
            slot: data.slots[slot.id],
            teachers: [slot.defaultTeacher],
            capacity: {
                current: 0,
                limit: slot.offerItemData.capacity,
            },
        })),
    ], (item) => Boolean(item.slot.hidden || item.capacity.current === item.capacity.limit));
};
exports.calculateAvailability = calculateAvailability;
// this searches lessons that have already started and have no reservations
function findStartedLessons(params, slotsData) {
    const { code, locations } = params;
    let availableSlots = _.filter(slotsData, { code });
    availableSlots = _.filter(availableSlots, (slot) => _.includes(locations, slot.location));
    availableSlots = _.filter(availableSlots, (slot) => !slot.reservations); // Those slots are included in findOpenLessons //FIXME: should be simplified
    availableSlots = _.filter(availableSlots, (slot) => slot.started);
    return availableSlots;
}
// this searches lessons that have reservations
function findOpenLessons(params, currentLessons) {
    return _.filter(currentLessons, (lesson) => {
        return lesson.participants.length < lesson.offerItemData.capacity &&
            lesson.slotData.code === params.code &&
            _.includes(params.locations, lesson.slotData.location);
    });
}
// this searches lessons that are not started and don't have any reservations
function findDefaultableSlots(params, slotsData, registeredLessons) {
    const { code, locations } = params;
    let availableSlots = _.filter(slotsData, { code });
    availableSlots = _.filter(availableSlots, (slot) => _.includes(locations, slot.location));
    availableSlots = _.filter(availableSlots, (slot) => !slot.reservations); // Those slots are included in findOpenLessons //FIXME: should be simplified
    // @ts-ignore
    availableSlots = _.filter(availableSlots, (slot) => !slot.lessons); // Those slots are included in findOpenLessons //FIXME: should be simplified
    availableSlots = _.filter(availableSlots, (slot) => isLocationRoomAvailable(slot, registeredLessons, slotsData));
    availableSlots = _.filter(availableSlots, (slot) => isTeacherAvailable(slot.defaultTeacher, slot, registeredLessons, slotsData));
    return availableSlots;
}
const overlaps = (aStart, aEnd, bStart, bEnd) => aStart.isBefore(bEnd) && aEnd.isAfter(bStart);
const toLessonExpanded = (slot) => ({
    slot: slot.id,
    teacher: slot.defaultTeacher,
    offerItemData: slot.offerItemData,
    slotData: slot,
    teacherData: slot.defaultTeacherData,
    participants: [],
});
const getCandidateSlotData = (candidate) => ('slotData' in candidate ? candidate.slotData : candidate);
const getCandidateTeacher = (candidate) => ('teacher' in candidate ? candidate.teacher : candidate.defaultTeacher);
function findSlotAvailabilityIssue(slotData, lessons, relatedSlots = []) {
    const sameDayLessons = lessons.filter((lesson) => lesson.slot !== slotData.id && lesson.slotData.day === slotData.day);
    const sameDaySlots = relatedSlots.filter((candidate) => candidate.id !== slotData.id && candidate.day === slotData.day);
    const timeConflict = _.find([...sameDaySlots, ...sameDayLessons], (candidate) => {
        return getCandidateTeacher(candidate) === slotData.defaultTeacher;
    });
    const candidateTimeConflict = _.find([...sameDaySlots, ...sameDayLessons], (candidate) => {
        const candidateSlotData = getCandidateSlotData(candidate);
        const candidateTeacher = getCandidateTeacher(candidate);
        return candidateTeacher === slotData.defaultTeacher &&
            overlaps(slotData.start, slotData.end, candidateSlotData.start, candidateSlotData.end);
    });
    if (candidateTimeConflict) {
        return {
            type: 'teacher-time',
            reason: 'korepetytor ma inną lekcję w tym czasie',
            lesson: 'slotData' in candidateTimeConflict ? candidateTimeConflict : toLessonExpanded(candidateTimeConflict),
        };
    }
    const candidateLocationConflict = _.find([...sameDaySlots, ...sameDayLessons], (candidate) => {
        const candidateSlotData = getCandidateSlotData(candidate);
        const candidateTeacher = getCandidateTeacher(candidate);
        return candidateTeacher === slotData.defaultTeacher &&
            candidateSlotData.location &&
            slotData.location &&
            candidateSlotData.location !== 'online' &&
            slotData.location !== 'online' &&
            candidateSlotData.location !== slotData.location;
    });
    if (candidateLocationConflict) {
        return {
            type: 'teacher-location',
            reason: 'korepetytor w innej placówce',
            lesson: 'slotData' in candidateLocationConflict ? candidateLocationConflict : toLessonExpanded(candidateLocationConflict),
        };
    }
    const candidateRoomConflict = _.find([...sameDaySlots, ...sameDayLessons], (candidate) => {
        const candidateSlotData = getCandidateSlotData(candidate);
        return candidateSlotData.location === slotData.location &&
            candidateSlotData.room === slotData.room &&
            slotData.location !== 'online' &&
            candidateSlotData.location !== 'online' &&
            overlaps(slotData.start, slotData.end, candidateSlotData.start, candidateSlotData.end);
    });
    if (candidateRoomConflict) {
        return {
            type: 'room',
            reason: 'pokój zajęty',
            lesson: 'slotData' in candidateRoomConflict ? candidateRoomConflict : toLessonExpanded(candidateRoomConflict),
        };
    }
    return undefined;
}
function isSlotBlocked(slotData, lessons, relatedSlots = []) {
    const sameDayLessons = lessons.filter((lesson) => lesson.slot !== slotData.id && lesson.slotData.day === slotData.day);
    const sameDaySlots = relatedSlots.filter((candidate) => candidate.id !== slotData.id && candidate.day === slotData.day);
    return [...sameDaySlots, ...sameDayLessons].some((candidate) => {
        var _a;
        const candidateSlotData = getCandidateSlotData(candidate);
        const candidateTeacher = getCandidateTeacher(candidate);
        const candidateIsTeacherConflict = candidateTeacher === slotData.defaultTeacher;
        const candidateIsTimeConflict = candidateIsTeacherConflict &&
            overlaps(slotData.start, slotData.end, candidateSlotData.start, candidateSlotData.end);
        const candidateIsLocationConflict = candidateIsTeacherConflict &&
            candidateSlotData.location &&
            slotData.location &&
            candidateSlotData.location !== 'online' &&
            slotData.location !== 'online' &&
            candidateSlotData.location !== slotData.location;
        const candidateIsRoomConflict = candidateSlotData.location === slotData.location &&
            candidateSlotData.room === slotData.room &&
            slotData.location !== 'online' &&
            candidateSlotData.location !== 'online' &&
            overlaps(slotData.start, slotData.end, candidateSlotData.start, candidateSlotData.end);
        if (!(candidateIsTimeConflict || candidateIsLocationConflict || candidateIsRoomConflict)) {
            return false;
        }
        const candidateLesson = 'slotData' in candidate ? candidate : toLessonExpanded(candidate);
        return Boolean(candidateLesson.slotData.started ||
            candidateLesson.participants.length > 0 ||
            ((_a = candidateLesson.slotData.reservations) === null || _a === void 0 ? void 0 : _a.length));
    });
}
const isActiveCandidate = (candidate) => {
    var _a;
    const candidateSlotData = getCandidateSlotData(candidate);
    const candidateLesson = 'slotData' in candidate ? candidate : toLessonExpanded(candidate);
    return Boolean(candidateSlotData.started ||
        ((_a = candidateSlotData.reservations) === null || _a === void 0 ? void 0 : _a.length) ||
        candidateLesson.participants.length > 0);
};
function findRoomAvailabilityConflict(slotData, lessons, relatedSlots = []) {
    const issue = findSlotAvailabilityIssue(slotData, lessons, relatedSlots.filter(isActiveCandidate));
    return (issue === null || issue === void 0 ? void 0 : issue.type) === 'room' ? issue.lesson : undefined;
}
function isLocationRoomAvailable(slotData, lessons, relatedSlots = []) {
    return !findRoomAvailabilityConflict(slotData, lessons, relatedSlots);
}
function findTeacherAvailabilityConflict(teacherName, slotData, lessons, relatedSlots = []) {
    const issue = findSlotAvailabilityIssue(slotData, lessons.filter((lesson) => lesson.teacher === teacherName), relatedSlots.filter((candidate) => getCandidateTeacher(candidate) === teacherName && isActiveCandidate(candidate)));
    if (!issue)
        return undefined;
    if (issue.type === 'teacher-location') {
        return { reason: 'location', lesson: issue.lesson };
    }
    if (issue.type === 'teacher-time') {
        return { reason: 'time', lesson: issue.lesson };
    }
    return undefined;
}
function isTeacherAvailable(teacherName, slotData, lessons, relatedSlots = []) {
    return !findTeacherAvailabilityConflict(teacherName, slotData, lessons, relatedSlots);
}
